import platformDetection from './PlatformDetection';
import playController from './PlayController';
import appParameters from './AppParameters';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';

const audioVolumeUtils = {
    audioContext: undefined,
    gainNodes: [],
    isInitialized: false,
    isListnerAdded: false,
    isActiveFunctionality: false,
    buffers: [],
    callBackDraws: [],
    toolType: 1, // 0 - none, 1 - both AE and C, 2 - only C, 3 - only AE

    isAvailableVolume() {
        var toolTypeValue = this.toolType;

        switch (toolTypeValue) {
            case 0: {
                return false;
                break;
            }

            case 1: {
                return true;
                break;
            }

            case 2: {
                return !audioToolUtils.isAudioTool();
                break;
            }

            case 3: {
                return audioToolUtils.isAudioTool();
                break;
            }
        }
    },
    useVolumeFunctionality() {
        if (this.isAvailableVolume())
            return this.isActiveFunctionality;
        else
            return false;
    },
    addEventListener() {
        if (!this.isAvailableVolume())
            return;

        if (this.isListnerAdded)
            return;

        this.isActiveFunctionality = platformDetection.isIOS();
        this.isListnerAdded = true;

        if (this.useVolumeFunctionality()) {
            if (!this.audioContext)
                this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

            this.init();

            window.addEventListener('touchstart', this.init.bind(this));
            // window.addEventListener('click', this.init.bind(this));
        }
    },
    removeEventListener() {
        if (this.useVolumeFunctionality()) {
            window.removeEventListener('touchstart', this.init);
            // window.removeEventListener('click', this.init);
        }
    },
    reset() { // should create a new context because something broke the old audio context when call reactNativeBridge.stopRecording()
        return; // for NCA-169: it seems that after 4 recordings and reseting context, the new context can't be created anymore.

        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        this.isInitialized = false;

        if (playController.isAudioEditorAvailable())
            playController.updateAudioElements();
    },
    init() {
        if (this.isInitialized || !this.useVolumeFunctionality())
            return;

        if (!this.audioContext)
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

        if (!this.audioContext)
            return;

        if (this.audioContext.state === 'suspended') {
            this.audioContext.resume();
            setTimeout(this.playFirstTime.bind(this), 40);
        } else {
            this.playFirstTime();
        }
    },
    playFirstTime() {
        if (!this.audioContext)
            return;

        this.isInitialized = true;

        return;

        var url = appParameters.clipartBucket() + '/movieaudioeditor/1837856.mp3';

        this.loadBufferSound(url, true);
    },
    loadBufferSound(url, autoplayBuffer = false) {
        if (this.buffers[url])
            return;

        if (!this.audioContext)
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        request.originalUrl = url;

        // Decode asynchronously
        request.onload = function() {
            try {
                this.audioContext.decodeAudioData(request.response, function (buffer) {
                    if (autoplayBuffer)
                        this.playBufferSound(buffer);
                    else {
                        var originalUrl = request.originalUrl;
                        this.buffers[originalUrl] = buffer.getChannelData(0);

                        if (this.callBackDraws[originalUrl]) {
                            this.callBackDraws[originalUrl]();
                            delete this.callBackDraws[originalUrl];
                        }
                    }

                }.bind(this));
            } catch (e) {
                // error
            }
        }.bind(this);

        request.send();
    },
    playBufferSound(buffer) {
        var source = this.audioContext.createBufferSource();
        source.buffer = buffer;

        var gainNode;

        if (!this.audioContext.createGain)
            this.audioContext.createGain = this.audioContext.createGainNode;

        gainNode = this.audioContext.createGain();

        source.connect(gainNode);
        gainNode.connect(this.audioContext.destination);

        gainNode.gain.value = 0;

        if (!source.start)
            source.start = source.noteOn;

        if (!source.start)
            source.start = source.play;

        if (!source.stop)
            source.stop = source.noteOff;

        source.start(0);
    },
    drawWaveform(buffer) {
        var canvas = document.createElement('canvas');
        canvas.width = 600;
        canvas.height = 70;
        canvas.style.position = 'absolute';
        canvas.style.top = 136 + 'px';
        canvas.style.left = 222 + 'px';
        canvas.style.background = 'white';
        document.body.appendChild(canvas);

        var data = buffer.getChannelData(0),
            width = canvas.width,
            height = canvas.height,
            ctx = canvas.getContext('2d'),
            amp = height / 2;

        // var step = Math.ceil( data.length / width );
        // for(var i=0; i < width; i++){
        //     var min = 1.0;
        //     var max = -1.0;
        //     for (var j=0; j<step; j++) {
        //         var datum = data[(i*step)+j];
        //         if (datum < min)
        //             min = datum;
        //         if (datum > max)
        //             max = datum;
        //     }
        //     ctx.fillRect(i,(1+min)*amp,1,Math.max(1,(max-min)*amp));
        // }

        var x, y, i, n = data.length;
        ctx.strokeStyle = 'yellow';
        ctx.fillStyle = '#303030';
        ctx.fillRect(0, 0, width,height);
        ctx.beginPath();
        ctx.moveTo(0, amp);
        for (i=0; i<n; i++) {
            x = ((i *width) / n);
            y = ((data[i] * amp) + amp);
            ctx.lineTo(x, y);
        }
        ctx.stroke();
        ctx.closePath();
    },

    regularAudios: [],
    regularAudioUrl: [],

    prepareSounds() {
        if (!this.useVolumeFunctionality())
            return;

        if (!this.audioContext) {
            this.reset();
            return;
        }

        this.gainNodes = [];
    },
    loadBufferForUrl(url, uuid, audios, volume) {
        if (url == '')
            return;

        if (!this.audioContext)
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        request.originalUrl = url;

        // Decode asynchronously
        request.onload = function() {
            try {
                this.audioContext.decodeAudioData(request.response, function (buffer) {
                    this.createSourceContent(buffer, uuid, audios, volume);
                }.bind(this));
            } catch (e) {
                // error
            }
        }.bind(this);

        request.send();
    },
    createSourceContent(buffer, uuid, audios, volume) {
        if (!this.audioContext)
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

        var source = this.audioContext.createBufferSource();
        source.buffer = buffer;

        var gainNode;

        if (!this.audioContext.createGain)
            this.audioContext.createGain = this.audioContext.createGainNode;

        gainNode = this.audioContext.createGain();
        gainNode.gain.value = 0;

        source.connect(gainNode);
        gainNode.connect(this.audioContext.destination);

        if (!source.start)
            source.start = source.noteOn;

        if (!source.start)
            source.start = source.play;

        if (!source.stop)
            source.stop = source.noteOff;

        source.play = source.start;
        source.pause = source.stop;

        this.gainNodes[uuid] = gainNode;
        audios[uuid] = source;

        if (volume >= 0) { // should autoplay
            this.executeMediaAction(uuid, volume, true);
        }
    },
    refreshSource(audios, key) {
        // this will stop sound

        if (!this.audioContext)
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

        if (audios[key]) {
            var buffer = audios[key].buffer;
            audios[key].buffer = null;
            this.createSourceContent(buffer, key, audios);
        }
    },
    changeVolume(uuid, volume) {
        if (!this.useVolumeFunctionality() || !this.audioContext)
            return;

        if (this.gainNodes && this.gainNodes[uuid]) {
            this.gainNodes[uuid].gain.value = volume;
        }
    },
    checkSound(url, uuid) {
        if (url != '' && url != this.regularAudioUrl[uuid]) {
            this.regularAudioUrl[uuid] = url;
            this.loadBufferForUrl(url, uuid, this.regularAudios);
        } else if (url == '' && this.regularAudioUrl[uuid]) {
            this.regularAudioUrl[uuid] = '';
            this.regularAudios[uuid] = undefined;
        }
    },
    executeMediaAction(uuid, volume, play, onEndAction) {
        this.refreshSource(this.regularAudios, uuid);

        if (play) {
            var audio = this.regularAudios[uuid];

            if (audio) {
                this.changeVolume(uuid, volume);
                audio.onended = onEndAction;
                audio.play();
            }
        }
    },
    loadAndPlaySound(url, uuid, volume = -1) {
        if (url != '' && url != this.regularAudioUrl[uuid]) {
            this.regularAudioUrl[uuid] = url;
            this.loadBufferForUrl(url, uuid, this.regularAudios, volume);
        } else {
            if (url == '' && this.regularAudioUrl[uuid]) {
                this.executeMediaAction(uuid, 0, false);
                this.regularAudioUrl[uuid] = '';
                this.regularAudios[uuid] = undefined;
            } else
                this.executeMediaAction(uuid, volume, true);
        }
    }
};

export default audioVolumeUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/AudioVolumeUtils.js
 **/